<script lang="ts" setup>
withDefaults(
  defineProps<{
    link?: string | null
    name: string
  }>(),
  { link: null }
)
</script>

<template>
  <NuxtLink
    class="
      flex basis-1/4 cursor-pointer items-center justify-stretch text-nowrap rounded-xl
      p-2 text-main-dark !no-underline transition-colors
      hover:bg-main-gray-low
    "
    :to="link"
  >
    <SvgIcon class="!size-6" name="outlined/clock" />

    <span class="ml-3 block text-base tracking-[-0.01em]">
      {{ name }}
    </span>
  </NuxtLink>
</template>
